import { createSlice, PayloadAction} from '@reduxjs/toolkit';



import { AppThunk } from '../store';
import firebase from 'firebase';
import { auth, firestore} from '../firebase';
import { AdminUserData, AuthMethod } from '../types/auth';

interface UserState {
  user: AdminUserData | null;
  signInLoading: AuthMethod | null;
  userStateLoading: boolean;
  error: string | null;
}

const initialState: UserState = {
  user: null,
  userStateLoading: true,
  signInLoading: null,
  error: null,
}


const service = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setSignInLoading(state, action: PayloadAction<AuthMethod | null>): UserState {
      return { ...state, signInLoading: action.payload, }
    },
    setUserStateLoading(state, action: PayloadAction<boolean>): UserState {
      return { ...state, userStateLoading: action.payload, }
    },
    setError(state, action: PayloadAction<string | null>): UserState {
      return { ...state, error: action.payload, }
    },
    setUserData(state, action: PayloadAction<AdminUserData | null>): UserState {
      return { ...state, user: action.payload, }
    },
  }
});

const fetchUserData = async (fbUser: firebase.User): Promise<AdminUserData | null> => {
  try {
    const doc = await firestore.collection('users').doc(fbUser.uid).get();
    if (!doc.exists) {
      return null;
    }

    const data = doc.data();

    if (!data?.adminRoles || data?.adminRoles.length === 0) {
      return null;
    }

    return {
      id: fbUser.uid,
      name: data?.firstName ?? '',
      email: fbUser.email ?? '',
      roles: data.adminRoles,
    }
  }
  catch(e) {
    console.error(e);
    return null;
  }
}

const init = (): AppThunk => async (dispatch, getState) => {
  
  // dispatch(service.actions.setUserStateLoading(true));

  auth().onAuthStateChanged(async (fUser) => {
    // console.log('onAuthStateChanged', fUser);
    if (fUser) {
      const userData = await fetchUserData(fUser);
      dispatch(service.actions.setUserData(userData));
    }
    dispatch(service.actions.setUserStateLoading(false));
  });
}

const signOut = (): AppThunk => async (dispatch, getState) => {
  
  await auth().signOut();
  dispatch(service.actions.setUserData(null));
}

const signIn = (method: AuthMethod): AppThunk => async (dispatch, getState) => {
  dispatch(service.actions.setSignInLoading(method));

  try {
    
    let provider;
    if (method === 'facebook.com') {
      provider = new auth.FacebookAuthProvider();
    }
    else {
      provider = new auth.GoogleAuthProvider();
    }

    const result = await auth().signInWithPopup(provider);

    console.log(result);
  }
  catch (e) {
    dispatch(service.actions.setError(e.message));
    console.error(e);
  }
  finally {
    dispatch(service.actions.setSignInLoading(null));
  }
}

export const actions = {
  init,
  signIn,
  signOut,
}

export default service.reducer;